import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full space-x-2 flex justify-end" }

import { computed } from 'vue';

import { useCategoriesStore } from '@/stores/dictionary/categories';
import { useModalsStore } from '@/stores/modals';
import { useI18n } from 'vue-i18n';
import { CategoryResource } from '@shared/resources/category';

import PageWrapper from '@components/page-wrapper/PageWrapper.vue';
import Button from '@ui-kit/controls/button/Button.vue';
import ModalConfirmation from '@components/modals/ModalConfirmation.vue';
import ModalManageCategory from './modals/ModalManageCategory.vue';

import { Table, TableClientDataManager, TableComponentParams } from '@ui-kit/table';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageCategories',
  setup(__props) {

const categoriesStore = useCategoriesStore();
const modalsStore = useModalsStore();
const { t } = useI18n();

const tableManager = new TableClientDataManager({
  providedData: computed(() => categoriesStore.data),
  searchBy: ['name'],
  loading: computed(() => categoriesStore.isLoad),
});

const tableParams = computed<TableComponentParams<CategoryResource>>(() => {
  return {
    columns: [
      {
        name: 'name',
        data: 'name',
        title: t('fields.name'),
      },
      {
        name: 'actions',
        title: '',
        width: 200,
      },
    ],
  };
});

function manageCategory(category?: CategoryResource) {
  modalsStore.addModal({
    component: ModalManageCategory,
    props: {
      data: category,
    },
  });
}
function removeCategory(category: CategoryResource) {
  modalsStore.addModal({
    component: ModalConfirmation,
    props: {
      title: t('pages.categories.remove-label'),
      danger: true,
      confirmText: t('common.actions.delete'),
      confirm: () => {
        return categoriesStore.remove(category.id);
      }
    }
  });
}

return (_ctx: any,_cache: any) => {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (_openBlock(), _createBlock(PageWrapper, {
    title: _ctx.$t('navigation.categories')
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(Table), {
        "data-manager": _unref(tableManager),
        params: _unref(tableParams)
      }, {
        "header-right": _withCtx(() => [
          _createVNode(Button, {
            size: "xl",
            "button-type": "outline",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (manageCategory()))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_FontAwesomeIcon, {
                icon: "plus",
                class: "mr-2"
              }),
              _createTextVNode(_toDisplayString(_ctx.$t('common.actions.create_new')), 1)
            ]),
            _: 1
          })
        ]),
        "cell-actions": _withCtx(({ row }) => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(Button, {
              size: "sm",
              onClick: ($event: any) => (manageCategory(row))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, {
                  icon: "pen",
                  class: "mr-2"
                }),
                _createTextVNode(_toDisplayString(_ctx.$t('common.actions.edit')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            _createVNode(Button, {
              size: "sm",
              color: "danger",
              onClick: ($event: any) => (removeCategory(row))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_FontAwesomeIcon, { icon: "trash" })
              ]),
              _: 2
            }, 1032, ["onClick"])
          ])
        ]),
        _: 1
      }, 8, ["data-manager", "params"])
    ]),
    _: 1
  }, 8, ["title"]))
}
}

})